export default function copyTextWithFormat(htmlText: string) {
  try {
    // Regex to remove HTML tags except for <em> tag
    htmlText = htmlText.replace(/<(?!\/?em\s*\/?>).*?>/g, "");
    const htmlElement = document.createElement("div");
    htmlElement.innerHTML = htmlText;
    document.body.appendChild(htmlElement);
    const range = document.createRange();
    range.selectNode(htmlElement);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);
    document.execCommand("copy");
    window.getSelection()?.removeAllRanges();
    document.body.removeChild(htmlElement);
  } catch (error) {
    console.error("Fallback: Oops, unable to copy", error);
  }
}
